import React from 'react';
import './elements-svg.css';

const TechLines3 = (props) => {
  const { width, height } = props;
  
  return (
    <svg id="Layer_1" width={width} height={height} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.08 48.28">
      <g className="stroke-2">
        <path className="even-odd fill-pink" d="m2.83,32.2h171.24L205.37.91h275.71v-.91H204.99l-31.29,31.29H2.83v.91Z"/>
        <path className="even-odd fill-pink" d="m23.67,45.93h60.49l13.86-13.86-.64-.64-13.59,13.59H23.67v.91Z"/>
        <path className="even-odd fill-pink" d="m133.7,17.76H47.82v-.91h86.26l14.58,14.58-.64.64-14.31-14.31h-.01Z"/>
        <path className="fill-pink"
              d="m48.46,20.03c-1.52.36-3.04-.58-3.39-2.1-.36-1.52.58-3.04,2.1-3.39,1.52-.36,3.04.58,3.39,2.1.36,1.52-.58,3.04-2.1,3.39Z"/>
        <path className="fill-pink"
              d="m3.47,34.48c-1.52.36-3.04-.58-3.39-2.1-.36-1.52.58-3.04,2.1-3.39,1.52-.36,3.04.58,3.39,2.1.36,1.52-.58,3.04-2.1,3.39Z"/>
        <path className="fill-pink"
              d="m24.31,48.2c-1.52.36-3.04-.58-3.39-2.1-.36-1.52.58-3.04,2.1-3.39,1.52-.36,3.04.58,3.39,2.1.36,1.52-.58,3.04-2.1,3.39Z"/>
      </g>
    </svg>
  );
}

export default TechLines3;